export enum Permissions {
    ReadProjectPermission = "read_project_permission",
    CreateProjectPermission = "create_project_permission",
    UpdateProjectPermission = "update_project_permission",
    DeleteProjectPermission = "delete_project_permission",
    InviteUserPermission = "invite_user_permission",
}